import { Model, ModelAttributes, model, modelConfig, reference } from "@mixitone/oom";
import { setAccountId } from "./concerns/SetAccountId";
import Account from "./Account";
import AccountUser from "./AccountUser";
import Club from "./Club";
import FundingAppeal from "./FundingAppeal";
import { Database } from "./database.types";

const config = modelConfig(
  {
    account_id: {
      type: "string",
    },
    body_html: {
      type: "string",
    },
    club_id: {
      type: "string",
    },
    content_blocks: {
      type: "json",
      jsonType: {} as unknown[] | null,
    },
    created_at: {
      type: "datetime",
    },
    created_by_account_user_id: {
      type: "string",
    },
    funding_appeal_id: {
      type: "string",
    },
    is_deleted: {
      type: "boolean",
    },
    locked_at: {
      type: "datetime",
    },
    name: {
      type: "string",
    },
    render_mode: {
      type: "enum",
      enumType: "" as Database["public"]["Enums"]["funding_appeal_email_template_render_mode"],
    },
    updated_at: {
      type: "datetime",
    },
  },
  {},
  {
    account: reference(() => Account as any, "account_id"),
    club: reference(() => Club as any, "club_id"),
    created_by_account_user: reference(() => AccountUser as any, "created_by_account_user_id"),
    funding_appeal: reference(() => FundingAppeal as any, "funding_appeal_id"),
  },
);

interface FundingAppealEmailTemplate extends ModelAttributes<typeof config> {}

@setAccountId
@model("funding_appeal_email_templates", config)
class FundingAppealEmailTemplate extends Model<typeof config> {}

export default FundingAppealEmailTemplate;
